import React, { PureComponent } from 'react';
import { Form, Input, Alert, message } from 'antd';
import get from 'lodash/get';
import { isManualVehicleVrm } from '@fxtr/i18n';
import Modal from '../../../../../components/Modal';
import { FormItemStyled } from './styled';
import { changeVrm } from '../api';
import BookingPageContext from '../../../context';

const FormItem = Form.Item;

class EditVrmModal extends PureComponent {
  static contextType = BookingPageContext;

  state = {
    confirmLoading: false,
  };

  onValidateForm = () => {
    const { booking, closePopup } = this.props;

    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      try {
        this.setState({ confirmLoading: true });
        await changeVrm(booking.bookingId, values.vrm, booking.segment);
        message.success('The VRM was successfully changed.');
        closePopup();
        this.context.reloadBooking();
      } catch (error) {
        message.error(get(error, 'response.data.message', error.message));
        this.setState({ confirmLoading: false });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { booking, closePopup, openedPopup } = this.props;

    const formItemLayout = {
      labelAlign: 'left',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
    };

    return (
      <Modal
        title="Edit VRM"
        visible={openedPopup === 'EditVrmModal'}
        onOk={this.onValidateForm}
        onCancel={closePopup}
        okText="Save"
        confirmLoading={this.state.confirmLoading}
      >
        <Alert
          message={
            <>
              Before saving, check on Fixter.co.uk/Fixter.fr that the new VRM is valid and if the customer
              prices need to be updated.
            </>
          }
          type="error"
          showIcon
        />

        {!isManualVehicleVrm(booking.vehicle.vrm) && (
          <p style={{ marginTop: '5px' }}> Original Vrm: {booking.vehicle.vrm}</p>
        )}

        <Form {...formItemLayout}>
          <FormItemStyled label="New VRM:">
            {getFieldDecorator('vrm', {
              rules: [{ required: true, message: 'vrm is required' }],
            })(<Input placeholder="vrm" />)}
          </FormItemStyled>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditVrmModal);
